import { render, staticRenderFns } from "./DataFromStendistTime.vue?vue&type=template&id=7dd2b9a0&"
import script from "./DataFromStendistTime.vue?vue&type=script&lang=ts&"
export * from "./DataFromStendistTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports